module.exports = __webpack_public_path__ + "static/media/img111.6eb94839.jpg";